import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../public/img/home/solution/en_home_goldcircle.png'
import _imports_1 from '../../../public/img/investorkits/23-investor_pdficon.png'


const _withScopeId = n => (_pushScopeId("data-v-63f1f8c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "committee-box" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"home-title\" data-v-63f1f8c2><div class=\"title\" style=\"display:flex;align-items:center;color:#000;margin:7px 0;\" data-v-63f1f8c2><img src=\"" + _imports_0 + "\" alt=\"\" data-v-63f1f8c2><div style=\"display:flex;flex-direction:column;\" data-v-63f1f8c2><p style=\"color:#000;font-size:1.5rem;margin-left:-15px;letter-spacing:2px;\" data-v-63f1f8c2>WEBCAST &amp; EVENTS</p></div></div></div>", 1)
const _hoisted_3 = { class: "press-content" }
const _hoisted_4 = ["item"]
const _hoisted_5 = { style: {"display":"flex","justify-content":"flex-start","align-items":"center","gap":"20px"} }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_7 = { style: {"color":"#000","font-size":"1rem","max-width":"90%","line-height":"1.7"} }

import Footer from "@/components/home/Footer.vue";
  import { ref, reactive } from "vue";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Webcast',
  setup(__props) {

  const datas = reactive([
    {
      name: "Fendan Technology Closes Series B Strategic Financing to Further Its Growth in Marriage and Childbearing Sectors",
      date: "2019-8-13",
    },
    {
      name: "Fendan Technology Awarded the “Golden Rose” Most Potential Enterprise of Wedding Industry",
      date: "2018-12-9",
    },
    {
      name: "Fendan Technology Closes Series A Financing",
      date: "2017-8-7",
    }
  ]);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            item: item
          }, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)
            ]),
            _createElementVNode("hr", {
              style: _normalizeStyle([{"margin":"2rem 0","border-top":"1px solid rgba(12, 106, 204, 0.2)"}, {display: index === datas.length - 1 ? 'none' : ''}])
            }, null, 4)
          ], 8, _hoisted_4))
        }), 128))
      ])
    ]),
    _createVNode(Footer)
  ], 64))
}
}

})